/**
 * Helper method that translates a gender character to a readable string
 *
 * @param gender - The gender string to evaluate
 */
export default function genderString(gender: string): string {
  switch (gender) {
    case 'M':
      return 'Masculino';
    case 'F':
      return 'Femenino';
    default:
      return 'Otro';
  }
}
